import React, { useEffect, useMemo, useState } from 'react';
import CardContainer from 'components/Tvendo/Common/CardContainer';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import { useNavigate } from 'react-router-dom';
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  InputLabel,
  MenuItem,
  Paper,
  Radio,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
} from '@material-ui/core';
import RegularButton from 'components/CustomButtons/Button';
import { Check, Close, Search } from '@material-ui/icons';
import { onlyInteger, roundMony } from 'hooks/Pipe';
import { wsGet, wsPost } from 'services/WService';
import ConceptDetails from './components/ConceptDetails';
import PurchaseHeaderData from './components/PurchaseHeaderData';
import moment from 'moment';

function NewPurchaseDebitNote() {
  const navigate = useNavigate();
  const [processing, setProcessing] = useState(false);
  const [DocType, setDocType] = useState('I');

  const [ReceiptType, setReceiptType] = useState('');
  const [ReceiptSerie, setReceiptSerie] = useState('');
  const [ReceiptNumber, setReceiptNumber] = useState('');

  const [ncType, setNcType] = useState('07');
  const [ncSerie, setNcSerie] = useState('');
  const [ncNumber, setNcNumber] = useState('');
  const [comments, setComments] = useState('');

  const [refPurchase, setRefPurchase] = useState({});
  const [refLines, setRefLines] = useState([]);
  const [concepts, setConcepts] = useState([]);
  const [purchConcepts, setPurchConcepts] = useState([]);
  const [warehouseId, setWarehouseId] = useState();
  const [bpId, setBpId] = useState();

  // const [DocDate, setDocDate] = useState(moment().format('YYYY-MM-DD')); // Fecha contable
  // const [TaxDate, setTaxDate] = useState(moment().format('YYYY-MM-DD')); // Fecha documento

  const [DocDate, setDocDate] = useState('');
  const [TaxDate, setTaxDate] = useState('');

  const total = useMemo(() => {
    return refLines
      .filter((line) => line.checked === true)
      .reduce((prev, line) => {
        let lineTotal = (line.LineQuantity || line.Quantity) * (line.LinePrice || line.Price);
        return prev + lineTotal;
      }, 0);
  }, [refLines]);

  const totalConcepts = useMemo(() => {
    return concepts.reduce((prev, concept) => {
      let lineTotal = parseFloat(concept.price);
      return prev + lineTotal;
    }, 0);
  }, [concepts]);

  async function save() {
    if (DocDate === '') {
      return alert('Seleccione una fecha contable');
    }
    if (TaxDate === '') {
      return alert('Seleccione una fecha del documento');
    }
    if (ncSerie === '') {
      return alert('Seleccione la serie del documento');
    }
    if (ncNumber === '') {
      return alert('Seleccione el número del documento');
    }
    if (warehouseId === undefined) {
      return alert('Seleccione un almacén');
    }

    if (Object.keys(refPurchase).length === 0) {
      return alert('Seleccione el documento de referencia');
    }

    if (DocType === 'I') {
      await savePurchaseNc();
    } else {
      if (concepts.length === 0) {
        window.alert('Agregue al menos un detalle');
        return;
      }
      await saveConceptNc();
    }
  }

  async function savePurchaseNc() {
    let lines = refLines
      .filter((line) => line.checked === true)
      .map((line, index) => {
        return {
          LineNum: index,
          BaseLine: parseInt(line.LineNum) - 1,
          logi_product_id: line.logi_product_id,
          unitMsr: line.unitMsr,
          Quantity: line.LineQuantity || line.Quantity,
          Price: line.LinePrice || line.Price,
          TaxCode: line.TaxCode,
        };
      });

    let data = {
      type: DocType === 'I' ? 'PURCHASE' : 'CONCEPT',
      DocType,
      base_business_partner_id: refPurchase.base_business_partner_id,
      purch_purchase_id: refPurchase.purch_purchase_id,

      U_SYP_MDTD: ncType,
      U_SYP_MDSD: ncSerie,
      U_SYP_MDCD: ncNumber,

      Comments: comments,

      U_SYP_MDTO: refPurchase.U_SYP_MDTD,
      U_SYP_MDSO: refPurchase.U_SYP_MDSD,
      U_SYP_MDCO: refPurchase.U_SYP_MDCD,

      logi_warehouse_id: warehouseId,

      DocDate: DocDate,
      DocDueDate: DocDate,
      TaxDate: TaxDate,

      lines,
    };

    if (lines.length === 0) {
      alert('Elija al menos una línea');
      return;
    }

    if (total === 0) {
      alert('El valor del documento debe ser mayor a 0');
      return;
    }

    setProcessing(true);
    let res = await wsPost('purch/debit-note', data);
    if (res.success) {
      alert(res.message);
      navigate('/admin/compras/operaciones/nota-debito');
    } else {
      alert(res.message);
    }
    setProcessing(false);
  }

  async function saveConceptNc() {
    let lines = concepts.map((concept, index) => {
      return {
        LineNum: index,
        BaseLine: null,
        Dscription: concept.Dscription,
        Account: concept.Account,
        Quantity: 1,
        Price: concept.price,
        TaxCode: concept.TaxCode,
      };
    });

    let data = {
      type: DocType === 'I' ? 'PURCHASE' : 'CONCEPT',
      DocType,
      base_business_partner_id: bpId,
      purch_purchase_id: null,

      U_SYP_MDTD: ncType,
      U_SYP_MDSD: ncSerie,
      U_SYP_MDCD: ncNumber,

      Comments: comments,

      U_SYP_MDTO: refPurchase.U_SYP_MDTD,
      U_SYP_MDSO: refPurchase.U_SYP_MDSD,
      U_SYP_MDCO: refPurchase.U_SYP_MDCD,

      DocDate: DocDate,
      DocDueDate: DocDate,
      TaxDate: TaxDate,

      logi_warehouse_id: warehouseId,

      lines,
    };

    setProcessing(true);
    let res = await wsPost('purch/debit-note', data);
    if (res.success) {
      alert(res.message);
      navigate('/admin/compras/operaciones/nota-debito');
    } else {
      alert(res.message);
    }
    setProcessing(false);
  }

  async function getPurchase() {
    let res = await wsGet(
      `purch/debit-note/get-opch?ReceiptType=${ReceiptType}&ReceiptSerie=${ReceiptSerie}&ReceiptNumber=${ReceiptNumber}`,
    );

    if (res.success) {
      let { lines, ...opch } = res.data;

      // if (opch.DocType === 'S') {
      //   alert('La factura es de tipo servicio, no se puede referenciar');
      //   return;
      // }

      lines = lines.map((line) => {
        if (line.NumPerMsr > 1) {
          line.unitMsr = 'PZA';
          line.Price = line.Price / line.NumPerMsr;
          line.PriceAfVAT = line.PriceAfVAT / line.NumPerMsr;
          line.Quantity = line.Quantity * line.NumPerMsr;
        }
        return line;
      });

      setRefPurchase(opch);
      setRefLines(lines);
    } else {
      alert(res.message);
    }
  }

  const [checked, indeterminate] = useMemo(() => {
    const total = refLines.length;
    const checkedCount = refLines.filter((item) => item.checked === true).length;
    if (total === 0 || checkedCount === 0) return [false, false];
    let checked = false;
    let indeterminate = false;
    if (total === checkedCount) {
      checked = true;
    } else {
      indeterminate = true;
    }
    return [checked, indeterminate];
  }, [refLines]);

  function toogleChecked() {
    let newChecked = false;
    if (checked === true) {
      newChecked = false;
    } else if (checked === false && indeterminate === true) {
      newChecked = false;
    } else {
      newChecked = true;
    }
    setRefLines((lines) => {
      let newLines = [...lines];
      newLines = newLines.map((line) => {
        line.checked = newChecked;
        return line;
      });
      return newLines;
    });
  }

  async function listConcepts() {
    let res = await wsGet('purch/concept');
    if (res.success) {
      setPurchConcepts(res.data);
    }
  }

  useEffect(() => {
    if (DocType === 'S') {
      setRefPurchase({});
      setRefLines([]);
    }
  }, [DocType]);

  useEffect(() => {
    listConcepts();
  }, []);

  return (
    <>
      <CardContainer title="Nueva nota de débito compra">
        <GridContainer>
          {/* Tipo de documento (Compra/Concepto) */}
          <GridItem xs={12}>
            <h5 style={{ margin: 0, fontWeight: 400 }}>Tipo de nota débito</h5>
          </GridItem>
          <GridItem xs={12}>
            <FormControlLabel
              label="Mercadería"
              control={
                <Radio
                  checked={DocType === 'I'}
                  onClick={() => setDocType('I')}
                  disabled={processing}
                />
              }
              disabled={processing}
            />
            <FormControlLabel
              label="Servicio"
              control={
                <Radio
                  checked={DocType === 'S'}
                  onClick={() => setDocType('S')}
                  disabled={processing}
                />
              }
              disabled={processing}
            />
          </GridItem>
          {/* Busqueda Documento de referencia */}
          <GridItem xs={12}>
            <GridContainer>
              <GridItem xs={12}>
                <h5 style={{ margin: 0, fontWeight: 400 }}>
                  Documento de referencia{DocType === 'I' ? ' *' : ''}
                </h5>
              </GridItem>
              <GridItem xs={12} md={4} lg={2}>
                <FormControl fullWidth margin="normal" size="small" required={DocType === 'I'}>
                  <InputLabel shrink>Tipo documento</InputLabel>
                  <Select
                    value={ReceiptType}
                    required={DocType === 'I'}
                    disabled={processing}
                    onChange={(e) => setReceiptType(e.target.value)}
                  >
                    <MenuItem value="01">Factura</MenuItem>
                    <MenuItem value="03">Boleta</MenuItem>
                  </Select>
                </FormControl>
              </GridItem>
              <GridItem xs={12} md={4} lg={2}>
                <TextField
                  label="Serie"
                  fullWidth
                  name="U_SYP_MDSO"
                  margin="normal"
                  size="small"
                  required={DocType === 'I'}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  disabled={processing}
                  value={ReceiptSerie}
                  onChange={(e) => setReceiptSerie(e.target.value)}
                />
              </GridItem>
              <GridItem xs={12} md={4} lg={2}>
                <TextField
                  label="Código"
                  fullWidth
                  name="U_SYP_MDCO"
                  margin="normal"
                  size="small"
                  required={DocType === 'I'}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  disabled={processing}
                  value={ReceiptNumber}
                  onChange={(e) => setReceiptNumber(e.target.value)}
                />
              </GridItem>

              <GridItem xs={12} md={4} lg={2} onClick={getPurchase}>
                <RegularButton round justIcon color="primary">
                  <Search />
                </RegularButton>
              </GridItem>

              {/* DocDate Fecha Contable */}
              <GridItem xs={12} md={4} lg={2}>
                <TextField
                  label="Fecha Contable"
                  fullWidth
                  name="DocDate"
                  margin="normal"
                  type="date"
                  size="small"
                  required
                  value={DocDate}
                  onChange={(e) => setDocDate(e.target.value)}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  // disabled={true}
                  disabled={processing}
                />
              </GridItem>

              {/* TaxDate Fecha Documento Editable */}
              <GridItem xs={12} md={4} lg={2}>
                <TextField
                  label="Fecha Documento"
                  fullWidth
                  name="TaxDate"
                  margin="normal"
                  type="date"
                  size="small"
                  required
                  value={TaxDate}
                  onChange={(e) => setTaxDate(e.target.value)}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  disabled={processing}
                />
              </GridItem>
            </GridContainer>
          </GridItem>
          {/* Nota débito */}
          <GridItem xs={12}>
            <PurchaseHeaderData
              DocType={DocType}
              processing={processing}
              ncType={ncType}
              setNcType={setNcType}
              ncSerie={ncSerie}
              setNcSerie={setNcSerie}
              ncNumber={ncNumber}
              setNcNumber={setNcNumber}
              Comments={comments}
              setComments={setComments}
              refPurchase={refPurchase}
              bpId={bpId}
              setBpId={setBpId}
              warehouseId={warehouseId}
              setWarehouseId={setWarehouseId}
            />
          </GridItem>
        </GridContainer>
      </CardContainer>

      {DocType === 'I' && refLines.length > 0 && (
        <TableContainer component={Paper}>
          <Table style={{ minWidth: 1300 }} size="small">
            <TableHead>
              <TableRow>
                <TableCell width="50" align="center">
                  #
                </TableCell>
                <TableCell width="100" align="left">
                  COD.PDF
                </TableCell>
                <TableCell width="200" align="left">
                  Código
                </TableCell>
                <TableCell align="left">Producto</TableCell>
                <TableCell align="left" width="100">
                  UM
                </TableCell>
                <TableCell align="left" width="100">
                  Cant. x Paq
                </TableCell>
                <TableCell align="left" width="130">
                  Impuesto
                </TableCell>
                <TableCell align="left" width="130">
                  Cantidad
                </TableCell>
                <TableCell align="left" width="130">
                  Precio
                </TableCell>
                <TableCell align="left" width="130">
                  Importe
                </TableCell>
                <TableCell align="left" width="130">
                  Acciones
                  <Checkbox
                    checked={checked}
                    indeterminate={indeterminate}
                    onChange={toogleChecked}
                  />
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {refLines.map((line, index) => {
                function toggleLine() {
                  setRefLines((lines) => {
                    let newLines = [...lines];
                    let index = newLines.findIndex((item) => item.LineNum === line.LineNum);
                    newLines[index].checked = !!!newLines[index].checked;
                    return newLines;
                  });
                }

                function updateLine(field, value) {
                  setRefLines((lines) => {
                    let newLines = [...lines];
                    let index = newLines.findIndex((item) => item.LineNum === line.LineNum);
                    newLines[index][field] = value;
                    return newLines;
                  });
                }

                const lineTotal =
                  (line.LineQuantity || line.Quantity) * (line.LinePrice || line.Price);

                return (
                  <TableRow
                    key={line.LineNum}
                    style={{
                      // background: line.checked === true ? '#00ff7233' : '#ffbebe59',
                      background: line.checked === true ? '#00ff7233' : 'none',
                    }}
                  >
                    <TableCell width="50" align="center">
                      {index + 1}
                    </TableCell>
                    <TableCell width="100" align="left">
                      {line.FrgItem}
                    </TableCell>
                    <TableCell width="200" align="left">
                      {line.ItemCode}
                    </TableCell>
                    <TableCell align="left">{line.Dscription}</TableCell>
                    <TableCell align="left" width="100">
                      {line.unitMsr}
                    </TableCell>
                    <TableCell align="left" width="100">
                      {line.NumPerMsr}
                    </TableCell>
                    <TableCell align="left" width="130">
                      {line.TaxCode}
                    </TableCell>
                    <TableCell align="left" width="130">
                      <TextField
                        name="Quantity"
                        value={line.LineQuantity || line.Quantity}
                        type="number"
                        inputProps={{ min: 0 }}
                        fullWidth
                        onChange={(e) => updateLine('LineQuantity', e.target.value)}
                        onKeyPress={onlyInteger}
                        disabled={processing}
                      />
                    </TableCell>
                    <TableCell align="left" width="130">
                      <TextField
                        name="Price"
                        value={line.LinePrice || line.Price}
                        type="number"
                        inputProps={{ min: 0, step: 0.0001 }}
                        fullWidth
                        onChange={(e) => updateLine('LinePrice', e.target.value)}
                        disabled={processing}
                      />
                    </TableCell>
                    <TableCell align="right">{roundMony(lineTotal).toFixed(2)}</TableCell>
                    <TableCell align="left" width="130">
                      <Checkbox
                        checked={line.checked || false}
                        disabled={processing}
                        onChange={toggleLine}
                      />
                    </TableCell>
                  </TableRow>
                );
              })}
              <TableRow>
                <TableCell colSpan={8}></TableCell>
                <TableCell align="left">{roundMony(total).toFixed(2)}</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      )}

      {DocType === 'S' && (
        <ConceptDetails
          processing={processing}
          concepts={concepts}
          setConcepts={setConcepts}
          purchConcepts={purchConcepts}
          total={totalConcepts}
        />
      )}

      <RegularButton
        color="success"
        style={{ float: 'right', marginTop: '15px' }}
        onClick={save}
        disabled={processing}
      >
        {processing ? 'Guardando...' : 'Guardar'}
      </RegularButton>
    </>
  );
}

export default NewPurchaseDebitNote;
